<template>
<section>

	<div class="d-flex flex-row align-items-center justify-content-between">
		<h3 class="mb-0">Equipment</h3>

		<div v-if="!isFinalized">
			<button type="button" class="btn btn-success" v-on:click="addEquipment">
				<i class="fa fa-plus"></i>
				Add Equipment
			</button>
		</div>
	</div>

	<table-list
		:records="mutatedEquipment"
		:fields="equipmentFields"
		:has-delete="!isFinalized"
		:has-edit="!isFinalized"
		:simple-delete="true"
		:sortable="true"
		:hide-record-count="true"
		record-name="Equipment Type"
		v-on:delete="deleteObject($event,quoteObjectResource)"
		v-on:edit="editEquipment">
	</table-list>

	<equipment-type-picker-modal
	 	:visible="equipmentEditModal.visible"
	 	:title="equipmentEditModal.title"
	 	:record="equipmentEditModal.selectedType"
	 	:allow-manual-type="true"
	 	v-on:confirmAdd="confirmAdd"
	 	v-on:closeModal="equipmentEditModal.visible = false">
	</equipment-type-picker-modal>

</section>
</template>
<script type="text/javascript">
import TableList from "@/components/TableList"

import EquipmentTypePickerModal from "@/components/super_components/EquipmentTypePickerModal"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"

import InvoiceMixins from "@/mixins/InvoiceMixins.js"

export default {
	name: "QuoteEquipmentSection",
	components: {
		TableList,
		EquipmentTypePickerModal,
		FormGroup,
		Field
	},
	mixins: [InvoiceMixins],
	props: ["quoteEquipment","quoteId","quoteObjectResource","isFinalized"],
	data() {
		return {
			equipmentFields: [
				{label: "Type",key:"typeName"},
				{label: "Qty", key:"qtyWithUnit",align:"right"},
				{label: "Rate",key:"rate",align:"right"},
				{label: "Total",key:"total",align:"right"}
			],
			equipmentEditModal: {
				visible: false,
				title: "Edit Equipment",
				selectedType: false,
				payload: {
					type: "Equipment",
					invoice_id: this.quoteId
				},
				lineTotal: 0
			},
			equipmentTypes: []
		}
	},
	computed: {
		mutatedEquipment() {
			let vm = this

			return this.quoteEquipment.map(eq => {

				let type = vm.equipmentTypes.find(type => type.id == eq.equipment_type_id)

				let qty = 0
				if ("hrs" in eq && eq.hrs)
					qty = eq.hrs
				else if ("qty" in eq && eq.qty)
					qty = eq.qty

				let unit = "hour"
				if ("unit" in eq && eq.unit)
					unit = eq.unit
				else if ("charge_out_rate_unit" in type && type.charge_out_rate_unit != 'hrs') //legacy handling
					unit = "day"

				let rate = +eq.rate
				eq.rate = rate.toFixed(2)

				eq.qtyWithUnit = qty + " " + unit + "s"

				return eq
			})
		}
	},
	methods: {
		typeSelected(type_id) {
			let vm = this

			let eq = this.equipmentTypes.find(eq => eq.id == type_id)

			if (eq) {
				this.equipmentEditModal.payload.rate = eq.charge_out_rate
				this.equipmentEditModal.payload.unit = eqObj.charge_out_rate_unit
				this.equipmentEditModal.payload.equipment_type_id = type_id
			}
		},
		addEquipment() {
			this.equipmentEditModal.visible = true
			this.equipmentEditModal.title = "Add Equipment to Quote"
			this.equipmentEditModal.selectedType = {
				rate: "",
				hrs: ""
			}
			this.equipmentEditModal.payload = {
				invoice_id: this.quoteId,
				type: "Equipment",
				equipment_type_id: null,
				unit: "hour",
				rate: "",
				qty: ""
			}
		},
		editEquipment(record) {
			this.equipmentEditModal.visible = true
			this.equipmentEditModal.title = "Edit Equipment"
			this.equipmentEditModal.payload = JSON.parse(JSON.stringify(record))

			this.equipmentEditModal.selectedType = {
				type_name: record.typeName,
				type_id: record.equipment_type_id,
				rate: record.rate,
				qty: record.qty,
				unit: record.unit
			}

			this.equipmentEditModal.payload.type = "Equipment"
			this.equipmentEditModal.payload.invoice_id = this.quoteId
		},
		confirmAdd(payload) {
			let total = +payload.qty * +payload.rate

			this.equipmentEditModal.payload.rate = payload.rate 
			this.equipmentEditModal.payload.qty = payload.qty
			this.equipmentEditModal.payload.unit = payload.qty_unit
			this.equipmentEditModal.payload.equipment_type_id = payload.equipment_type_id

			this.equipmentEditModal.payload.total = total.toCurrency()
			this.equipmentEditModal.payload.totalRaw = total

			this.equipmentEditModal.payload.name = payload.typeName
			this.equipmentEditModal.payload.typeName = payload.typeName

			this.saveObject(this.equipmentEditModal,false,this.quoteObjectResource)
		},
		fetchData() {
			let vm = this

			let promises = [
				this.getJSON("EquipmentType/get")
			]

			Promise.all(promises).then(responses => {
				if (responses[0].success) {
					vm.equipmentTypes = responses[0].data
				}
			})
		}
	},
	created() {
		this.fetchData()
	}
} 
</script>